import React, { useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Password } from 'primereact/password';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { fetchEspPosts, fetchInvPosts } from '../../../redux/thunk/thunk.js';
import { useDispatch } from 'react-redux';
import { dictionary } from '../../../dictionary.js';

const EspAccess = (props) => {
  const dispatch = useDispatch();
  const POST_TAB = props.postTab;
  const [visible, setVisible] = useState(true);
  const [resError, setResError] = useState(null);
  const [username, setUsername] = useState('admin_user');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const isDevelopment = process.env.NODE_ENV === 'development';
  const API_URL = isDevelopment
    ? process.env.REACT_APP_API_URL
    : 'https://eld-timer-backend-service.api.prod.sit.sys.odj.cloud/';

  const addSuccessMsg = () => {
    toast.current.show({
      severity: 'success',
      summary: dictionary.toast_summary_success,
      detail: dictionary.toast_access,
    });
  };

  const handleHide = () => {
    props.setActiveTab(POST_TAB);
    setVisible(false);
  };

  const handleAccess = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}auth/admin-login`, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: username,
          password: password,
        }),
      });

      if (response.ok) {
        addSuccessMsg();
        setResError(null);
        await Promise.all([
          dispatch(fetchEspPosts()),
          dispatch(fetchInvPosts()),
        ]);
        setLoading(false);
        props.setShowEspTable(true);
        setVisible(false);
        sessionStorage.setItem('isAdmin', 'true');
      } else {
        const message = await response.text();
        setResError(message);
        console.error(message);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Dialog
        header={dictionary.user_logs_btn_esp_table_access}
        visible={visible}
        style={{ width: '50%' }}
        onHide={handleHide}
      >
        {loading && (
          <div className="loading-wrapper">
            <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="2" animationDuration="3s" />
          </div>
        )}
        <div className="esp-info-wrapper">
          <i className="pi pi-info-circle"></i>
          <p>{dictionary.user_logs_btn_esp_table_access_info}</p>
        </div>
        <form className="p-fluid login-access" onSubmit={handleAccess}>
          <div className="p-field">
            <label htmlFor="username">{dictionary.login_access_user}</label>
            <InputText id="username" disabled value={username} onChange={(e) => setUsername(e.target.value)} />
          </div>
          <div className="p-field">
            <label htmlFor="password">{dictionary.login_access_password}</label>
            <Password
              id="password"
              placeholder={dictionary.login_access_password_enter}
              value={password}
              feedback={false}
              onChange={(e) => setPassword(e.target.value)}
              className={resError ? 'p-invalid' : null}
              toggleMask
            />
            {resError ? <small className="p-error">{resError}</small> : null}
          </div>
          <Button type="submit" label={dictionary.login_access_btn} />
        </form>
        <Toast ref={toast} />
      </Dialog>
    </>
  );
};

export default EspAccess;
